var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat"},[_c('p',[_vm._v("如有问题，请联系"),_c('a',{on:{"click":_vm.openLive800}},[_vm._v("在线客服")])])])}
var staticRenderFns = []

export { render, staticRenderFns }